import React from 'react';
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

import css from './SemiFinishedProductListModal.module.css';
import SemiFinishedProductModal from "../SemiFinishedProductModal/SemiFinishedProductModal";


const SemiFinishedProductListModal = () => {
    const {t} = useTranslation();
    const {semiFinishedProductsForModalArray} = useSelector(store => store.semiFinishedProducts);


    return (
        <div className={css.wrap}>
            {semiFinishedProductsForModalArray.length > 0 ? (
                semiFinishedProductsForModalArray.map((obj, index) => <SemiFinishedProductModal
                    key={obj.id}
                    semiFinishedProduct={obj}
                    index={index}
                />)
            ) : <div className={css.noData}>{t('no-data')}</div>}
        </div>
    );
};

export default React.memo(SemiFinishedProductListModal);